<lib-navigation-tab [navLinks]="mainTabs()" class="bottom-bar"></lib-navigation-tab>